import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading-spinner"
}
const _hoisted_2 = { class: "show-fullscreen p-grid p-m-0 p-p-4 p-jc-center p-ai-center" }
const _hoisted_3 = { class: "abort-button" }
const _hoisted_4 = { class: "p-col-4 p-md-6 p-lg-4 p-text-center" }
const _hoisted_5 = { class: "p-col-8 p-md-6 p-lg-4 p-text-center" }
const _hoisted_6 = { class: "p-col-12 p-text-center" }
const _hoisted_7 = {
  key: 0,
  class: "p-component view-title"
}
const _hoisted_8 = {
  key: 1,
  class: "p-component view-title"
}
const _hoisted_9 = {
  key: 2,
  class: "p-component view-title"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ProcessTimeline = _resolveComponent("ProcessTimeline")!
  const _component_ProcessItemAdminUser = _resolveComponent("ProcessItemAdminUser")!
  const _component_ProcessItemTemplates = _resolveComponent("ProcessItemTemplates")!
  const _component_ProcessItemSummary = _resolveComponent("ProcessItemSummary")!
  const _component_BlockUI = _resolveComponent("BlockUI")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("i", {
            class: "mdi mdi-spin mdi-loading",
            style: {"fontSize":"8rem"}
          }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    _createVNode(_component_BlockUI, { blocked: _ctx.loading }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              icon: "mdi mdi-arrow-left",
              class: "p-button-rounded p-button-outlined",
              onClick: _ctx.onCancelProcess
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_ProcessTimeline, { processItems: _ctx.processItems }, null, 8, ["processItems"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.processItems[0].active)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_7, _toDisplayString(_ctx.$t('System-Administration.General.AdminUser')), 1))
                : _createCommentVNode("", true),
              (_ctx.processItems[1].active)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_8, _toDisplayString(_ctx.$t('System-Administration.Templates.Templates')), 1))
                : _createCommentVNode("", true),
              (_ctx.processItems[2].active)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_9, _toDisplayString(_ctx.$t('System-Administration.General.Summary')), 1))
                : _createCommentVNode("", true)
            ]),
            (_ctx.processItems[0].active)
              ? (_openBlock(), _createBlock(_component_ProcessItemAdminUser, {
                  key: 0,
                  adminUser: _ctx.adminUser,
                  onUpdate: _ctx.onUpdateAdminUser,
                  onGoToPreviousOrNextStep: _ctx.goToPreviousOrNextStep
                }, null, 8, ["adminUser", "onUpdate", "onGoToPreviousOrNextStep"]))
              : _createCommentVNode("", true),
            (_ctx.processItems[1].active)
              ? (_openBlock(), _createBlock(_component_ProcessItemTemplates, {
                  key: 1,
                  onUpdate: _ctx.onUpdateTemplates,
                  onGoToPreviousOrNextStep: _ctx.goToPreviousOrNextStep
                }, null, 8, ["onUpdate", "onGoToPreviousOrNextStep"]))
              : _createCommentVNode("", true),
            (_ctx.processItems[2].active)
              ? (_openBlock(), _createBlock(_component_ProcessItemSummary, {
                  key: 2,
                  tenant: _ctx.tenantSetup.tenant,
                  tenantExists: _ctx.tenantExists,
                  adminUser: _ctx.adminUser,
                  allTemplates: _ctx.allTemplates,
                  onGoToPreviousOrNextStep: _ctx.goToPreviousOrNextStep
                }, null, 8, ["tenant", "tenantExists", "adminUser", "allTemplates", "onGoToPreviousOrNextStep"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["blocked"])
  ], 64))
}